import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Wrap any /admin/* page.  Requires the user to be logged in.
 * Pass `permission="view_subscribers"` to also gate on a specific permission.
 * Owner role bypasses permission checks automatically.
 */
export default function ProtectedRoute({ children, permission }) {
  const { user, loading, hasPermission } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="auth-loading"
           style={{ minHeight: "60vh", display: "grid", placeItems: "center", color: "#5b5e69" }}>
        Checking session…
      </div>
    );
  }

  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/admin/login?next=${next}`} replace />;
  }

  if (permission && !hasPermission(permission)) {
    return (
      <div data-testid="auth-forbidden"
           style={{ minHeight: "60vh", display: "grid", placeItems: "center", padding: 32, textAlign: "center" }}>
        <div>
          <div style={{ color: "#A32D2D", fontWeight: 700, letterSpacing: 2 }}>403 · FORBIDDEN</div>
          <h2 style={{ fontFamily: "Bebas Neue, Arial, sans-serif", color: "#0A1628", fontSize: 32, margin: "8px 0" }}>
            You don&apos;t have access to this section
          </h2>
          <p style={{ color: "#5b5e69" }}>
            Ask the owner (Lanre) to grant you <code>{permission}</code> in /admin/users.
          </p>
        </div>
      </div>
    );
  }

  return children;
}
